export type ProductPaymentMode = 'pg' | 'combined' | 'bank';
const enabled = (value: unknown) => value === true || value === 1 || value === '1';
export function productPaymentLabel(isPg?: boolean | number | null, mode?: ProductPaymentMode | null) {
  return mode === 'bank' || mode !== 'pg' && isPg != null && !enabled(isPg) ? '무통장' : 'PG';
}
export function productDeliveryLabel(individual?: boolean | number, price?: number | string | null) {
  return enabled(individual) ? `개별 배송 · ${Number(price || 0).toLocaleString('ko-KR')}원` : '기본 배송';
}
